module.exports = "/_next/static/files/a9e2e98ef633932c6117ed16a8a84b79.png";